import SEO from "./SEO";
import SEOConfig, { publisherRef } from "./SEOConfig";
import truncateAtWord from "../../utils/helpers/truncateAtWord";

const NewsSEO = ({ post, url }) => {
  if (!post) return null;

  // Get the best available image
  const getImageUrl = (post) => {
    if (!post?.mainImage?.data?.attributes) return "";

    const { formats, url } = post.mainImage.data.attributes;

    // Prefer WebP format for better performance
    if (formats?.lg_webp?.url) return formats.lg_webp.url;
    if (formats?.md_webp?.url) return formats.md_webp.url;
    if (formats?.sm_webp?.url) return formats.sm_webp.url;

    return url;
  };

  // The editor's excerpt when there is one, otherwise the article's opening text.
  const getDescription = (post) => {
    if (post.excerpt?.trim()) return truncateAtWord(post.excerpt);

    let textContent = "";
    if (post.textBlock) {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = post.textBlock;
      textContent = truncateAtWord(tempDiv.textContent || tempDiv.innerText || "");
    }

    return textContent || `${post.title} — новини Slick Racing Ukraine`;
  };

  const imageUrl = getImageUrl(post);
  const description = getDescription(post);
  const category = post.category?.data?.attributes?.name || "Новини";
  const tags = post.tags?.data?.map((tag) => tag.attributes.name) || [];

  // Add relevant keywords for the news article
  const keywords = [
    ...tags,
    "Slick Racing Ukraine",
    "симрейсинг новини",
    "сімрейсінг новини",
    category,
    "віртуальний автоспорт",
  ].filter(Boolean);

  const { siteUrl } = SEOConfig;
  const fullUrl = url.startsWith("http") ? url : `${siteUrl}${url}`;

  // Define breadcrumbs for better navigation and SEO
  const breadcrumbs = [
    {
      name: "Головна",
      url: siteUrl,
    },
    {
      name: "Новини",
      url: `${siteUrl}/news`,
    },
    {
      name: post.title,
      url: fullUrl,
    },
  ];

  // Create structured data for the article
  const schema = {
    "@context": "https://schema.org",
    "@type": "NewsArticle",
    headline: post.title,
    image: imageUrl ? [imageUrl] : undefined,
    datePublished: post.publishedAt,
    dateModified: post.updatedAt || post.publishedAt,
    author: {
      "@type": "Person",
      name: post.author || "Slick Racing Ukraine",
    },
    publisher: publisherRef,
    description: description,
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": fullUrl,
    },
    keywords: tags.join(", "),
    articleSection: category,
  };

  return (
    <SEO
      title={post.title}
      description={description}
      keywords={keywords}
      image={imageUrl}
      url={fullUrl}
      schema={schema}
      canonical={fullUrl}
      type="article"
      breadcrumbs={breadcrumbs}
      lang="uk"
      author={post.author}
      publishedTime={post.publishedAt}
      modifiedTime={post.updatedAt || post.publishedAt}
    />
  );
};

export default NewsSEO;
